import { TableFromObject } from '../table';

export const Cost = ({ job }) => {
  const cost = job.metrics?.cost || {};
  const clean = {};
  for (const key of Object.keys(cost)) {
    const val = cost[key] || 0;
    clean[key] = '$' + val.toFixed(4);
  }

  const len = job.results?.items?.length;
  if (len && cost.total) {
    clean['per 1k'] = '$' + ((cost.total / len) * 1000).toFixed(2);
  }

  return (
    <div>
      <TableFromObject obj={clean} />
    </div>
  );
};
